import React from 'react'
import cn from 'classnames'

import Text from './Text'
import Illustration from './Illustration'
import styles from './About.module.css'

export default () => (
  <div className={styles.container}>

    <div className={cn(styles.content, 'reveal')}>
      <h4>About us</h4>
    </div>

    <div className={styles.illustration}>
      <Illustration type="attic" />
    </div>

    <div className={cn(styles.content, 'reveal')}>
      <h1>Digi-tallest on<br />Södermalm</h1>
      <Text size="large">We’re equal parts business minded as we are humble creators in our virtual playgrounds. Together we strive to make the worlds products a tad bit better for everyone with our digitally bare hands.</Text>
      <Text size="large">We could talk about all the fun things we do as a team. The challenges we take on as individuals. All the places we’ve visited and cool people we met. But to be frank thats what most creative studios do. Come visit ut as find out what sets us apart from others and if that would suit <a href="https://m.me/madebybowtie">You</a> too.</Text>
    </div>

  </div>
)



// WEBPACK FOOTER //
// ./src/components/About.js